export default "__VITE_ASSET__f_rxNkb0__"